import styled from "styled-components";

export const Container = styled.div`
    height: 15vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;